(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name settings.factory:SettingsService
   *
   * @description
   *
   */
  angular
    .module('settings')
    .factory('SettingsService', SettingsService);

  function SettingsService($q, $http,EndpointsService) {
    var SettingsServiceBase = {};

    SettingsServiceBase.changePassword = function (object) {
        var deferred = $q.defer();
        EndpointsService.getLinks().then(function (response) {
            $http.put(response.links.authenticationAdmin_changePassword,object)
                .success(function (data) {
                    deferred.resolve(data);
                }).error(function (msg, code) {
                    deferred.reject(msg);
                });
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    SettingsServiceBase.getSmsAndNotifications = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.smsAndEmailNotification, {params: params})
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.changeUserBasedNotifications = function (object) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.userBasedNotificationOrder,object)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.changeTrrBasedNotifications = function (object) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.trrBasedNotificationOrder,object)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getAdditionalTransactionConfirmation = function (params) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.additionalTransactionConfirmation)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.changeAdditionalTransactionConfirmation = function (object) {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.post(response.links.additionalTransactionConfirmation,object)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getPeriodTypes = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.notificationOrderPeriodType)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getTimeTypes = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.notificationOrderTimeType)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getPeriodOfWeekTypes = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.notificationOrderPeriodOfWeekType)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };

    SettingsServiceBase.getPeriodOfMonthTypes = function () {
      var deferred = $q.defer();
      EndpointsService.getLinks().then(function (response) {
        $http.get(response.links.notificationOrderPeriodOfMonthType)
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (msg, code) {
          deferred.reject(msg);
        });
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    };


    return SettingsServiceBase;
  }
}());
